import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export default function GreenFocus() {
  const { ref, isVisible } = useScrollAnimation(0.1);

  return (
    <section className="py-28 bg-[#FAFAF8]">
      <div className="max-w-7xl mx-auto px-8">

        {/* Image banner */}
        <div className="w-full h-80 rounded-3xl overflow-hidden relative mb-16">
          <img
            src="https://public.readdy.ai/ai/img_res/7242d16dba1dca051471a38b4d6da5a6.jpg"
            alt="Keskkond on meie prioriteet"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-dark-green/80 via-dark-green/50 to-transparent" />
          <div className="absolute inset-0 flex items-center">
            <div className="px-12 max-w-xl">
              <span className="text-eco-green text-xs md:text-[24px] font-bold uppercase tracking-[0.2em] block mb-3">
                Roheline mõtteviis
              </span>
              <p className="text-3xl md:text-4xl font-extrabold text-white leading-tight">
                Iga projekti juures mõtleme{' '}
                <span className="text-eco-green">roheliselt</span>
              </p>
            </div>
          </div>
        </div>

        {/* Content cards */}
        <div
          ref={ref}
          className={`transition-all duration-700 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          <div className="text-center mb-12">
            <span className="inline-flex items-center gap-2 text-eco-green text-xs md:text-4xl font-bold uppercase tracking-[0.2em] mb-4">
              <div className="w-6 h-0.5 bg-eco-green" />
              Keskkonnasõbralik lähenemine
              <div className="w-6 h-0.5 bg-eco-green" />
            </span>
            <h2 className="text-4xl md:text-5xl font-extrabold text-gray-900 max-w-2xl mx-auto leading-tight">
              Puhtam, kiirem ja keskkonnasõbralik lahendus
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 mb-12">
            {[
              {
                icon: 'ri-recycle-line',
                title: 'Puhtam ja korrastatud objekt',
                desc: 'Hoiame tööala organiseeritud kogu ehituse vältel',
              },
              {
                icon: 'ri-earth-line',
                title: 'Vähem kulusid ja jäätmeid',
                desc: 'Vähendame prügi hulka ja optimeerime jäätmekäitluse kulusid objektil',
              },
              {
                icon: 'ri-shield-check-line',
                title: 'Vastavus nõuetele',
                desc: 'Tagame korrektse jäätmekäitluse vastavalt seadustele ja nõuetele',
              },
            ].map((item) => (
              <div
                key={item.title}
                className="bg-white rounded-2xl p-8 border border-gray-100 flex flex-col gap-4"
              >
                <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-pale-green">
                  <i className={`${item.icon} text-2xl text-eco-green`} />
                </div>
                <div>
                  <h3 className="text-base font-bold text-gray-900 mb-2">{item.title}</h3>
                  <p className="text-gray-500 text-sm leading-relaxed">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>

          {/* Quote */}
          <div className="bg-pale-green rounded-2xl p-10 text-center">
            <i className="ri-leaf-line text-4xl text-eco-green mb-4 block" />
            <p className="text-xl md:text-2xl font-bold text-dark-green max-w-2xl mx-auto leading-relaxed">
              "Suuname maksimaalselt ehitusjäätmeid taaskasutusse või korduskasutusse,
              vähendades prügilasse mineva materjali hulka."
            </p>
            <p className="text-base text-dark-green/70 max-w-xl mx-auto mt-4 leading-relaxed">
              Kõik jäätmed käideldakse vastavalt Eesti keskkonnanõuetele ja parimatele praktikatele.
            </p>
            <div className="mt-6 inline-flex items-center gap-2 text-eco-green text-sm font-semibold">
              <div className="w-8 h-0.5 bg-eco-green" />
              IISRAL Recycling OÜ
            </div>
          </div>
        </div>

      </div>
    </section>
  );
}
